import React from 'react';
import Text from 'global/components/text';
import { HOpHeader } from './styles';

export const OpHeader = (props) => {
  const { icon, title, color } = props;

  return (
    <HOpHeader as={Text} type="title_large">
      <div style={{ color, marginRight: 8 }}>{icon}</div>
      {title}
    </HOpHeader>
  );
};
